import Image from "@namia/image";
import React from "react";

const HcCta = ({ image, headline, link, cta }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-cta wp-block-kehittamo-block-hc bg-[#dc6b25] mb-[-4rem] xl:mb-[-8rem]">
      <div className="flex flex-col items-center gap-8 xl:mt-4 xl:flex-row xl:items-start xl:justify-start">
        <div className="flex flex-col items-center xl:w-3/5 xl:items-start">
          <h2 className="!text-black text-center xl:!text-left mb-8 xl:text-[2.5rem] xl:font-bold items-start">
            {headline}
          </h2>
          <a
            className="text-black group hover:no-underline shadow-lg"
            href={link}
          >
            <div className="bg-white text-base font-semibold rounded-2xl py-3 px-10 group-hover:!bg-yellow-400 transition">
              <div className="text-center text-black group-hover:no-underline">
                {cta}
              </div>
            </div>
          </a>
        </div>
        <div className="xl:w-2/5 relative max-w-96 xl:max-w-none">
          <Image
            className="shadow-xl"
            alt="alt"
            base64={image.base64}
            onError={() => {}}
            placeholder={image.placeholder}
            onLoad={() => {}}
            placeholderBase64={image.placeholderBase64}
            ratio={image.width / image.height}
            src={image.src}
            srcset={image.srcset}
          />
        </div>
      </div>
    </div>
  );
};

export default HcCta;
